import React from 'react';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import {
  Button,
  Card,
  Container,
  FormHelperText,
  Grid
} from '@material-ui/core';
import Header from './Header';
import MyCheckbox from './MyCheckbox';

function TrainingHistory({ formData, setFormData, nextPage, prevPage }) {
  return (
    <React.Fragment>
      <Header
        title="Let's talk about who you are as an athlete."
        subtitle="Which best describes your training history?"
      />
      <Container maxWidth="md" style={{ height: '500px', padding: '1rem' }}>
        <Card raised>
          <Formik
            initialValues={formData}
            validationSchema={yup.object({
              trainingHistory: yup.array()
                .required('Please select an option')
            })}
            onSubmit={(values, actions) => {
              // console.log(JSON.parse(JSON.stringify(values)));
              setFormData(values);
              nextPage();
            }}
          >
            {formik => (
              <Form>
                <Container maxWidth="sm" style={{ padding: '1rem' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <MyCheckbox name="trainingHistory" type="checkbox" value="weightlifting" label="Olympic Weightlifting" />
                    </Grid>
                    <Grid item xs={12}>
                      <MyCheckbox name="trainingHistory" type="checkbox" value="powerlifting" label="Powerlifting" />
                    </Grid>
                    <Grid item xs={12}>
                      <MyCheckbox name="trainingHistory" type="checkbox" value="fitness" label="CrossFit" />
                    </Grid>
                    <Grid item xs={12}>
                      <MyCheckbox name="trainingHistory" type="checkbox" value="sports" label="Team Sports" />
                    </Grid>
                    <Grid item xs={12}>
                      <MyCheckbox name="trainingHistory" type="checkbox" value="none" label="None of the above" />
                    </Grid>
                    {!!formik.errors && (
                      <Grid item xs={12}>
                        <FormHelperText error={!!formik.errors}>{formik.errors.trainingHistory}</FormHelperText>
                      </Grid>
                    )}
                    <Grid item xs={4}>
                      <Button variant="contained" onClick={prevPage} fullWidth>Back</Button>
                    </Grid>
                    <Grid item xs={8}>
                      <Button type="submit" variant="contained" color="primary" fullWidth>Next</Button>
                    </Grid>
                  </Grid>
                  {/* <pre>{JSON.stringify(formik.values, null, 2)}</pre>
                  <pre>{JSON.stringify(formik.errors, null, 2)}</pre> */}
                </Container>
              </Form>
            )}
          </Formik>
        </Card>
      </Container>
    </React.Fragment>
  );
}

export default TrainingHistory;